<app-header [hidden]="minimal"></app-header>
<mat-sidenav-container class="main-sidenav-container">
	<mat-sidenav mode="over" [(opened)]="menuIsOpened" [hidden]="minimal">
		<app-menu></app-menu>
	</mat-sidenav>
	<mat-sidenav-content id="body-container">
		<sl-feedback-panel variant="error" context="root"></sl-feedback-panel>
		<sl-feedback-panel variant="warn" context="root"></sl-feedback-panel>
		<ng-content></ng-content>
	</mat-sidenav-content>
	<mat-sidenav
		#flyout
		mode="over"
		class="flyout-container linq-drawer linq-drawer-lg"
		fixedInViewport="true"
		position="end"
		disableClose
		[hidden]="minimal"
	>
		<sl-feedback-panel variant="error" context="flyout"></sl-feedback-panel>
		<sl-feedback-panel variant="warn" context="flyout"></sl-feedback-panel>
		<ng-container id="flyoutPortal" *cdkPortalOutlet class="linq-drawer-outer-content"></ng-container>
	</mat-sidenav>
</mat-sidenav-container>